import { t } from '@lingui/core/macro';
import { Stack } from '@mui/material';
import { useRouter } from '@tanstack/react-router';
import { ChevronLeftIcon } from 'components/icons/ChevronLeftIcon';
import { useAuthStore } from 'stores/authStore';
import { StyledLink } from './styles';

type Props = {
  shouldSignOut: boolean;
  onSignOutNavigateTo?: '/login/email' | '/login/phone_number';
};

export const PageLayoutCancelLink = ({ shouldSignOut, onSignOutNavigateTo }: Props) => {
  const router = useRouter();
  const signOut = useAuthStore((state) => state.signOut);

  return (
    <StyledLink
      onClick={
        shouldSignOut
          ? () => signOut({ redirectTo: onSignOutNavigateTo })
          : () => router.history.back()
      }
    >
      <Stack direction="row" alignItems="center">
        <ChevronLeftIcon /> {shouldSignOut ? t`Déconnexion` : t`Retour`}
      </Stack>
    </StyledLink>
  );
};
